import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import { useFeatureToggles } from '@grandvisionhq/state'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'
import { DeliveryIndicatorGraphContainer } from '@grandvisionhq/www-next/slot-components/DeliveryIndicatorGraphContainer'
import { RxGlassesConfiguratorGraphContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { getDeliveryIndicatorConfig, sunglassesSpecifications } from '../../../configuration'
import { deliveryResolverFactory } from '../../../util/delivery-resolver-factory'

const slots: Props['slots'] = {
  BeforeUsps: () => (
    <DeliveryIndicatorGraphContainer deliveryResolverFactory={deliveryResolverFactory} />
  ),
  Configurator: RxGlassesConfiguratorGraphContainer,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const { isDynamicLineItemDeliveryEstimationEnabled } = useFeatureToggles()
  if (isDynamicLineItemDeliveryEstimationEnabled) {
    slots.BeforeUsps = undefined
  }
  return (
    <Page
      {...props}
      slots={slots}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={sunglassesSpecifications}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
